/* eslint-disable max-len */
/* eslint-disable require-jsdoc */
import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import FormLoader from "../../../components/formLoader";
import { withTheme } from "react-jsonschema-form";
import { Theme as MuiTheme } from "rjsf-material-ui";
import $ from "jquery";
import LinkItem from "../../../components/linkItem";
import { withSnackbar } from "notistack";
import {showToast} from "../../../utils/toast";
import {
  authenticate,
  getAllUserRoles,
  GetDataByDefaultValue,
} from "../../../servies/services";
// import Logo from '../../../images/wsfs-logo.jpg';
// import Footer from '../../../components/footer/footer'
import CryptoJS from "crypto-js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";


const Form = withTheme(MuiTheme);
const schema = require("./schema.json");
const uiSchema = {
  Password: {
    "ui:widget": "password",
  },
};

class login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      schema: schema,
      uiSchema: uiSchema,
      formData: {},
      loading: false,
      OrgLoading: false,
      role_list: [],
      remainingAttempts: 3,      
    };
  }

  onChange = (e) => {
    const formData = this.state.formData;
    formData[e.target.name] = e.target.value;
    this.setState({
      formData,
    });
    console.log("formData", this.state.formData);
  };

  // Function for getting handling all events

  onSubmit = async () => {
    console.log("this.state.formData", this.state.formData);
    if (
      this.state.formData.UserName == undefined ||
      this.state.formData.Password == undefined
    ) {
      const message = "Please select all fields";
      showToast.error(message);
      // this.props.enqueueSnackbar(message, {
      //   variant: "error",
      //   autoHideDuration: 5000,
      // });
    } else {
      // const DealType = $('#userroleid option:selected').attr('data-type');
      // const OrgName2 = $('#userroleid option:selected').attr('value');
      // console.log("DealType",DealType,OrgName2)
      var data = {};
      if (this.state.formData.UserName == "Trustee") {
        data = {
          UserName: this.state.formData.UserName,
          Password: this.state.formData.Password,
          OrgName: "trustee",
        };
        this.authenticate(data);
      } else if (this.state.formData.UserName == "Investor") {
        data = {
          UserName: this.state.formData.UserName,
          Password: this.state.formData.Password,
          OrgName: "investor",
        };
        this.authenticate(data);
      } else if (this.state.formData.UserName == "Investor2") {
        data = {
          UserName: this.state.formData.UserName,
          Password: this.state.formData.Password,
          OrgName: "investor",
        };
        this.authenticate(data);
      } else if (this.state.formData.UserName == "Investor3") {
        data = {
          UserName: this.state.formData.UserName,
          Password: this.state.formData.Password,
          OrgName: "investor",
        };
        this.authenticate(data);
      } else if (this.state.formData.UserName == "Servicer") {
        data = {
          UserName: this.state.formData.UserName,
          Password: this.state.formData.Password,
          OrgName: "servicer",
        };
        this.authenticate(data);
      } else if (this.state.formData.UserName == "admin") {
        data = {
          UserName: "admin",
          Password: this.state.formData.Password,
          OrgName: "trustee",
        };
        await this.authenticate(data); // this.GetUserRole(DealType,this.state.formData.OrgName)
      } else {
        const message = "Credentials Incorrect";
        showToast.error(message);
      }
    }
  };
  fetchDefaultData = async () => {
    const userId = sessionStorage.getItem("user_id");
    const userName = sessionStorage.getItem("user_name");

    if (!userId || !userName) {
      console.error("User data is missing from sessionStorage");
      return;
    }

    const data = { UserId: userId, UserName: userName };

    try {
      const APIResponse = await GetDataByDefaultValue(data);

      if (APIResponse.status === 200) {
        const { transaction_type } = APIResponse.data.result;

        // Set isSecuritisation in sessionStorage if transaction_type exists
        const checkTransactionType =
          transaction_type && transaction_type.length > 0
            ? transaction_type[0]
            : [];

        // console.log("Setting isSecuritisation:", checkTransactionType);
        sessionStorage.setItem("isSecuritisation", checkTransactionType);
        this.setState({ loading: false });

        window.location.assign("/investor/dashboard");
      } else {
        // this.props.enqueueSnackbar("Something went wrong", {
          // variant: "error",
          // autoHideDuration: 3000,
        // });
        showToast.error("Something went wrong");
      }
    } catch (error) {
      console.error("Error fetching default data:", error);
      // this.props.enqueueSnackbar("Failed to fetch data", {
      //   variant: "error",
      //   autoHideDuration: 3000,
      // });
      showToast.error("Failed to fetch data");
    } finally {
      this.setState({ loading: false });
    }
  };

  authenticate = async (data) => {
    this.setState({ loading: true });
    let APIResponse = null;
    try {
      APIResponse = await authenticate(data);
    } catch (error) {
      const message = "Login failed. Please check your credentials and try again";
      showToast.error(message);
      return;
    } finally {
      this.setState({ loading: false });
    }
    // console.log("authenticate", APIResponse, APIResponse.status)
    if (APIResponse !== null || APIResponse !== undefined) {
      if (APIResponse.status == 204) {
        this.setState({ remainingAttempts: this.state.remainingAttempts - 1 });

        if (this.state.remainingAttempts <= 0) {
          this.setState({ loading: true });

          setTimeout(
            () => this.setState({ loading: false, remainingAttempts: 3 }),
            180000
          );

          const message =
            "Your login attempts expired please wait for 3 minute";
          // this.props.enqueueSnackbar(message, {
          //   variant: "error",
          //   autoHideDuration: 5000,
          // });
          showToast.error(message);
        } else {
          const message = "Credentials Incorrect";
          // this.props.enqueueSnackbar(message, {
          //   variant: "error",
          //   autoHideDuration: 2000,
          // });
          showToast.error(message);
        }
      } else if (APIResponse.status !== 200) {
        const message = "Something went wrong, please try again";
        // this.props.enqueueSnackbar(message, {
        //   variant: "error",
        //   autoHideDuration: 5000,
        // });
        showToast.error(message);
      } else {
        if (APIResponse.data.isSuccess == false) {
          this.setState({ formLoader: false });
          const message = "Credentials Incorrect";
          // this.props.enqueueSnackbar(message, {
          //   variant: "error",
          //   autoHideDuration: 2000,
          // });
          showToast.error(message);
        } else {
          if (APIResponse.data != "undefined") {
            let OrgName = APIResponse.data.data.OrgName;
            sessionStorage.setItem("ChannelName", "nplchannel");
            // sessionStorage.setItem("DealType", DealType);
            sessionStorage.setItem("OrgName", OrgName);
            sessionStorage.setItem("user_id", APIResponse.data.data.UserID);
            sessionStorage.setItem("user_name", this.state.formData.UserName);
            sessionStorage.setItem("token", APIResponse.data.response.token);
            sessionStorage.setItem("jwtToken", APIResponse.data.jwt_token);
            // sessionStorage.setItem("ChannelName", DealType);
            sessionStorage.setItem("emailid", APIResponse.data.data.EmailID);

            var pass = this.state.formData.Password;
            var key = CryptoJS.enc.Latin1.parse("ALtReKQqUH1VTh43vNomog==");
            var iv = CryptoJS.enc.Latin1.parse("9988543267190345");
            var encrypted = CryptoJS.AES.encrypt(pass, key, {
              iv: iv,
              mode: CryptoJS.mode.CBC,
              padding: CryptoJS.pad.ZeroPadding,
            });
            console.log("encrypted: " + encrypted);
            var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
              iv: iv,
              padding: CryptoJS.pad.ZeroPadding,
            });
            console.log("decrypted: " + decrypted.toString(CryptoJS.enc.Utf8));
            sessionStorage.setItem("Pass", encrypted);

            // let ChannelName = DealType;
            // WSFS Stagin custer
            let peer = "peer0-" + APIResponse.data.data.OrgName;
            let p1 = "peer0-" + APIResponse.data.data.OrgName;

            let peers = [p1];
            sessionStorage.setItem("peer", peer);
            sessionStorage.setItem("peers", JSON.stringify(peers));

            if (this.state.formData.UserName == "Trustee") {
              this.setState({ formLoader: false });
              const message = "Logged in successfully";
              // this.props.enqueueSnackbar(message, {
              //   variant: "info",
              //   autoHideDuration: 2000,
              // });
              showToast.info(message);
              window.location.assign("/dashboard");
            } else if (this.state.formData.UserName == "Investor") {
              this.setState({ formLoader: false });
              const message = "Logged in successfully";
              sessionStorage.setItem("userrole", "Investor");
              sessionStorage.setItem("platform_name", "WSFS");
              // this.props.enqueueSnackbar(message, {
              //   variant: "info",
              //   autoHideDuration: 2000,
              // });
              showToast.info(message);
              await this.fetchDefaultData();
              window.location.assign("/investor/dashboard");
            } else if (this.state.formData.UserName == "Investor2") {
              sessionStorage.setItem("userrole", "Investor2");
              sessionStorage.setItem("platform_name", "WSFS");
              this.setState({ formLoader: false });
              await this.fetchDefaultData();
              const message = "Logged in successfully";
              // this.props.enqueueSnackbar(message, {
              //   variant: "info",
              //   autoHideDuration: 2000,
              // });
              showToast.info(message);
              window.location.assign("/investor/dashboard");
            } else if (this.state.formData.UserName == "Investor3") {
              sessionStorage.setItem("userrole", "Investor3");
              sessionStorage.setItem("platform_name", "WSFS");
              this.setState({ formLoader: false });
              await this.fetchDefaultData();
              const message = "Logged in successfully";
              // this.props.enqueueSnackbar(message, {
              //   variant: "info",
              //   autoHideDuration: 2000,
              // });
              showToast.info(message);
              window.location.assign("/investor/dashboard");
            } else if (this.state.formData.UserName == "admin") {
              this.setState({ formLoader: false });
              const message = "Logged in successfully";
              sessionStorage.setItem("userrole", "admin");
              // this.props.enqueueSnackbar(message, {
              //   variant: "info",
              //   autoHideDuration: 2000,
              // });
              showToast.info(message);
              window.location.assign(
                "/admin/users/" + APIResponse.data.data.OrgName + "/Pending"
              );
            } else {
              let token = APIResponse.data.response.token;
              window.location.assign("/dashboard/servicer");
              // this.GetAllDeals(DealType, token, peer, ChannelName, APIResponse.data.data.OrgName, APIResponse.data.data.FirstName)

              // if (APIResponse.data.data.OrgName == "wsfstrustee") {
              //   let token = APIResponse.data.response.token
              //   this.GetAllDeals(DealType, token, peer, ChannelName)
              // }
              // else if (APIResponse.data.data.OrgName === 'investor') {
              //   let token = APIResponse.data.response.token
              //   this.GetAllDeals(DealType, token, peer, ChannelName)
              // }
              // else {
              //   alert("Role not found - user type")
              // }
            }
          }
        }
      }
    }
  };

  async componentDidMount() {
    sessionStorage.clear();

    if (sessionStorage.getItem("OrgName") === null) {
      await this.getAllUserRoles();
    } else {
      const OrgName = JSON.parse(sessionStorage.getItem("OrgName"));
      this.setState({ OrgLoading: true });
      this.setState({ role_list: OrgName });
    }
  }

  getAllUserRoles = async () => {
    const APIResponse = await getAllUserRoles();
    if (APIResponse != null) {
      console.log("getAllUserRoles APIResponse.data", APIResponse.data);
      this.setState({ OrgLoading: true, role_list: APIResponse.data });

      sessionStorage.setItem("OrgName", JSON.stringify(APIResponse.data));
    } else {
      this.setState({ OrgLoading: true });
    }
  };

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword
    }));
  }

  render() {
    const x = this.state.formData;
    console.log("XXX", x);
    return (
      <React.Fragment>
        {this.state.loading === true ? <FormLoader></FormLoader> : ""}

        <React.Fragment>
          <div className="modalshiftcontent">
            <div className="input-container">
              <label className="label">Username</label>
              <input
                id=""
                name="UserName"
                onChange={this.onChange}
                className="input"
                type="text"
                value={this.state.formData.UserName}
              />
            </div>
            <div className="input-container">
              <label className="label">Password</label>
              <div style={{ position: "relative" }}>
                <input
                  name="Password"
                  type={this.state.showPassword ? "text" : "password"}
                  onChange={this.onChange}
                  className="input"
                  value={this.state.formData.Password}
                  style={{ paddingRight: "25px" }}
                />
                <button 
                  type="button"
                  onClick={this.togglePasswordVisibility} 
                  style={{ 
                    position: "absolute", 
                    right: "5px", 
                    top: "50%", 
                    transform: "translateY(-50%)", 
                    cursor: "pointer",
                    zIndex: "999",
                    border: "none",
                    background: "transparent",
                    fontSize: "18px",
                    color: "#555",
                    padding: "0",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  {this.state.showPassword ? (
                    <FontAwesomeIcon icon={faEyeSlash} style={{ color: "var(--primary)" }} />
                  ) : (
                    <FontAwesomeIcon icon={faEye} style={{ color: "var(--primary)" }} />
                  )}
                </button>
              </div>
            </div>
            {/* <p> <label>Role</label>

                  <div className="row">
                    <label className="form-check-label radiorole">
                      <input className="form-check-input radio-inline" type="radio" onChange={this.onChange} name="OrgName" id="gridRadios1" value="wsfstrustee" />
                      Trustee</label>
                    <label className="form-check-label radiorole">
                      <input className="form-check-input radio-inline" type="radio" onChange={this.onChange} name="OrgName" id="gridRadios2" value="investor" />
                      Issuer</label>

                  </div>
                  </p> */}

            {/* <select name="OrgName" id="userroleid" onChange={this.onChange} className="form-control" >
                    <option value={''} >{'Select Deal Name'}</option>
                    {this.state.role_list.length != 0 ?
                      Object.entries(this.state.role_list).map(([key, value]) => {
                        return (
                          <React.Fragment>

                            <optgroup label={key} > {key} </optgroup>
                            {value.map((item) => {
                              return (
                                <option data-type={key} selected={this.state.formData.UserRoleName == item.UserRoleName} value={item.UserRoleName}>{item.UserRoleName}</option>
                              );
                            })
                            }
                          </React.Fragment>
                        );
                      })
                      : ''}
                  </select> */}

            <p>
              <Button
                className="col-md-12"
                onClick={this.onSubmit}
                variant="contained"
                size="large"
                color="primary"
                id="signinbutton"
                type="submit"
                disabled={this.state.loading === true ? true : false}
              >
                Sign in
              </Button>
            </p>
          </div>
        </React.Fragment>

        <div className="loginCheckbox">
          <p className="lineDivider">
            <span>New to IntainADMIN?</span>
          </p>
          <LinkItem
            to={"/register"}
            variant="contained"
            className="loginBtn"
            title={"Create your Account"}
          >
            {" "}
          </LinkItem>

          {/* <div class="text-center Poweredby">Powered by <img id="wsfs_logo_first" style={{ width: "70px", height: "30px", marginTop:"-15px" }}
                                // src={"http://in-d.ai/wp-content/uploads/2020/11/WSFSLogo.png"
                                          src={"https://wsfs.intainabs.com/logo.jpg"
                                }
                            /></div> */}
        </div>
        {/* <Footer></Footer> */}
      </React.Fragment>
    );
  }
}

export default withSnackbar(login);
